












































import { Vue, Prop, Component } from 'vue-property-decorator'
import { AuthStore } from '~/store/auth'
import { fetchOrdersClient } from '#/api-marketplace/orders'

@Component
export default class OrdersPage extends Vue {
    orders: IOrderClient[] = []

    @AuthStore.State('authenticatedUser') authenticatedUser: IUser

    async fetchOrders() {
        this.orders = await fetchOrdersClient()
    }

    created() {
        this.fetchOrders()
    }
}
